"use strict";
function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;
//# sourceMappingURL=_getValue.js.map